export default __webpack_public_path__ + "static/media/logo_MNCR.e775e2df.png";